import React, { Component } from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import TextLoop from "react-text-loop";
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import Brand from "../elements/Brand";
import ContactThree from "../elements/contact/ContactThree";
import PortfolioList from "../elements/portfolio/PortfolioList";
import ServiceList from "../elements/service/ServiceList";
import BlogContent from "../elements/blog/BlogContent";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { ProgressBar } from 'react-bootstrap';


const SlideList = [
    {
        textPosition: 'text-left',
        category: 'Freelance Software Engineer',
        title: 'Hello, I’m <span>Kevin</span> Welcome to my World.',
        description: '',
        buttonText: '',
        buttonLink: ''
    }
]
interface Props { }
interface State {
    isOpen: boolean;
    modalImage?: string;
}

class PortfolioLanding extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }
    render(): React.ReactNode {
        let title = 'About Me'
        let description = ''
        const PostList = BlogContent;
        const { isOpen, modalImage } = this.state;
        return (
            <div className="active-dark">
                <Helmet pageTitle="Kevin Rifo Buana" />

                <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" />
                {/* Start Slider Area   */}
                <div id="home" className="fix">
                    <div className="slider-wrapper">
                        {/* Start Single Slide */}
                        {SlideList.map((value, index) => (
                            <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }} key={index}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className={`inner ${value.textPosition}`}>
                                                {value.category ? <span>{value.category}</span> : ''}
                                                <h1 className="title">Hi, I’m Kevin <br />
                                                    <TextLoop>
                                                        <span> Front-End Dev.</span>
                                                        <span> Back-End Dev.</span>
                                                        <span> Mobile App Dev.</span>
                                                        <span> System Analyst.</span>
                                                        <span> UI/UX Designer.</span>
                                                        <span> Content Writer.</span>
                                                        <span> Graphic Designer.</span>
                                                        <span> Entrapreneur.</span>
                                                        <span> Publisher.</span>
                                                    </TextLoop>{" "}
                                                </h1>
                                                <h2>based in Indonesia.</h2>
                                                {value.description ? <p className="description">{value.description}</p> : ''}
                                                {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* End Single Slide */}
                    </div>
                </div>
                {/* End Slider Area   */}

                {/* Start About Area */}
                <div id='about' className="about-area  pb--120  bg_color--1">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-start">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100 mt--100" src="/assets/images/portfolio/person/kevin-bw.jpg" alt="About Images" />
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner pt--100">
                                        <div className="section-title">
                                            <h2 className="title">{title}</h2>
                                            <p className="description">
                                                I am <strong>Kevin Rifo Buana</strong>, a results-driven software engineer with a natural intuition for strategic problem-solving. I excel at analyzing complex systems from a high-level architectural view down to the precise implementation details, seamlessly bridging tangible solutions with abstract concepts. Driven by continuous growth, I am intrinsically motivated to push boundaries and reach my fullest potential.
                                                <br /><br />
                                                Beyond my core technical competencies, I actively explore creative and analytical disciplines, including music production, photography, automotive engineering, science, and philosophical study.
                                            </p>                                        </div>
                                        <div className="row mt--30">
                                            <TabTwo tabStyle="tab-style--1" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* End About Area */}


                {/* Start Portfolio Area */}
                <div id="portfolio" className="fix">
                    <div className="portfolio-area ptb--120 bg_color--1">
                        <div className="portfolio-sacousel-inner">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                            <h2 className="title">My Latest Projects</h2>

                                        </div>
                                    </div>
                                </div>
                                <div className="row" >

                                    <PortfolioList styevariation="text-center mt--40" column="col-lg-4 col-md-6 col-sm-6 col-12" item="9" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Start Service Area  */}
                <div id="service" className="fix">
                    <div className="service-area creative-service-wrapper ptb--120 bg_color--5" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                        <h2 className="title">Things I Do</h2>

                                    </div>
                                </div>
                            </div>
                            <div className="row creative-service">
                                <div className="col-lg-12">
                                    <ServiceList item="6" column="col-lg-4 col-md-6 col-sm-6 col-12 text-left" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}

                <div className="rn-brand-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center service-style--3 mb--30">
                                    <h3 className="title">Having Great Experience Working With</h3>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mt--40 mt_sm--5 mt_md--5">
                                <Brand branstyle="branstyle--2" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fix">
                    <div className="container">
                        <div className="about-us-list">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center service-style--3 mb--30 mt--30">
                                        <h2 className="title">Skills</h2>

                                    </div>
                                </div>
                            </div>
                            <div className="rn-progress-bar progress-bar--3">
                                <div className="single-progress custom-color--1">
                                    <h6 >HTML/CSS</h6>
                                    <ProgressBar now={81} />
                                    <span className="label text-white">81%</span>
                                </div>

                                <div className="single-progress custom-color--2">
                                    <h6>Vue.js</h6>
                                    <ProgressBar now={75} />
                                    <span className="label text-white">75%</span>
                                </div>

                                <div className="single-progress custom-color--3">
                                    <h6 >React.js</h6>
                                    <ProgressBar now={55} />
                                    <span className="label text-white">55%</span>
                                </div>
                                <div className="single-progress custom-color--4">
                                    <h6>Flutter  (Dart)</h6>
                                    <ProgressBar now={90} />
                                    <span className="label text-white">90%</span>
                                </div>
                                <div className="single-progress custom-color--1">
                                    <h6 >Java/Kotlin (Android Native)</h6>
                                    <ProgressBar now={55} />
                                    <span className="label text-white">55%</span>
                                </div>
                                {/* <div className="single-progress">
                                    <h3 >Making Person I Like Losing Interest</h3>
                                    <ProgressBar now={100} />
                                    <span className="label text-white">100%</span>
                                </div>
                                 */}
                                <div className="single-progress custom-color--2">
                                    <h6 >Laravel</h6>
                                    <ProgressBar now={75} />
                                    <span className="label text-white">75%</span>
                                </div>
                                <div className="single-progress custom-color--3">
                                    <h6 >CodeIgniter</h6>
                                    <ProgressBar now={50} />
                                    <span className="label text-white">50%</span>
                                </div>
                                <div className="single-progress custom-color--4">
                                    <h6 >GoLang (Fiber)</h6>
                                    <ProgressBar now={60} />
                                    <span className="label text-white">60%</span>
                                </div>
                                <div className="single-progress custom-color--1">
                                    <h6 >MySQL & MongoDB</h6>
                                    <ProgressBar now={60} />
                                    <span className="label text-white">60%</span>
                                </div>
                                <div className="single-progress custom-color--2">
                                    <h6 >jQuery</h6>
                                    <ProgressBar now={50} />
                                    <span className="label text-white">50%</span>
                                </div>
                                <div className="single-progress custom-color--3">
                                    <h6 >Photo Editing</h6>
                                    <ProgressBar now={60} />
                                    <span className="label text-white">60%</span>
                                </div>
                                <div className="single-progress custom-color--4">
                                    <h6 >Video Editing</h6>
                                    <ProgressBar now={55} />
                                    <span className="label text-white">55%</span>
                                </div>
                                <div className="single-progress custom-color--1">
                                    <h6 >Googling & ChatGPTing</h6>
                                    <ProgressBar now={95} />
                                    <span className="label text-white">95%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}

                {/* Start Blog Area */}
                <div id="artwork" className="rn-brand-area pb--120 bg_color--1">
                    <div className="rn-blog-area ptb--120 bg_color--5 mb-dec--30">
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="section-title text-center">
                                        <h2>Artworks</h2>

                                    </div>
                                </div>
                            </div>
                            {isOpen && (
                                <Lightbox
                                    clickOutsideToClose={true}
                                    mainSrc={modalImage}
                                    onCloseRequest={() => this.setState({ isOpen: false })}
                                    imageLoadErrorMessage='Image Loading ...'
                                    enableZoom={true}
                                />
                            )}
                            <div className="row mt--60 mt_sm--40">
                                {PostList.map((value, i) => (
                                    <div className="col-lg-6 col-md-6 col-12" key={i}>
                                        <div className="blog blog-style--1">
                                            <div className="thumbnail">
                                                <img className="w-100" src={value.images} alt="Blog Images" />
                                            </div>
                                            <div className="content">
                                                <div className="blog-btn">
                                                    <a className="rn-btn text-white" href='#' onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setState({ modalImage: value.images, isOpen: true })
                                                    }}>see fullscreen</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
                {/* End Blog Area */}

                {/* Start COntact Area */}
                <div id="contact" className="fix">
                    <div className="rn-contact-area ptb--120 bg_color--1">
                        <ContactThree contactImages="/assets/images/about/about-9.jpg" contactTitle="Get Connected." />
                    </div>
                </div>
                {/* End COntact Area */}

                <FooterTwo />
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160} style={{

                        position: 'fixed',
                        bottom: 25,
                        right: 25,
                        cursor: 'pointer',
                        transitionDuration: '0.5s',
                    }}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

            </div>
        )
    }

}

export default PortfolioLanding;
